package dev.kotlinfest._2026.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import dev.kotlinfest._2026.components.layouts.PageLayoutData
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initSponsorsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Sponsors", fullWidth = true))
}

@Page("/sponsors")
@Layout(".components.layouts.PageLayout")
@Composable
fun SponsorsPage() {
    Column(Modifier.fillMaxWidth()) {
        Box(TicketHeroStyle.toModifier(), contentAlignment = Alignment.Center) {
            Column(Modifier.gap(8.px), horizontalAlignment = Alignment.CenterHorizontally) {
                H1(TicketHeroTitleStyle.toModifier().margin(0.px).toAttrs()) { Text("Sponsors") }
                SpanText("協賛企業一覧", TicketHeroSubTitleStyle.toModifier())
            }
        }
        Sponsors()
    }
}
